



































































import Vue from "vue";
import {
    mdiClose,
    mdiVolumeHigh,
    mdiVolumeMedium,
    mdiVolumeLow,
    mdiVolumeMute,
} from "@mdi/js";
export default Vue.extend({
    data() {
        return {
            userVolume: this.currentlyPlaying.device.volume_percent,
            mdiClose: mdiClose,
            mdiVolumeHigh: mdiVolumeHigh,
            mdiVolumeMedium: mdiVolumeMedium,
            mdiVolumeLow: mdiVolumeLow,
            mdiVolumeMute: mdiVolumeMute,
        };
    },
    props: { currentlyPlaying: { type: Object, required: true } },
    methods: {
        iconForVolume(volume: number): string {
            if (volume >= 75) {
                return this.mdiVolumeHigh;
            } else if (volume >= 50) {
                return this.mdiVolumeMedium;
            } else if (volume > 0) {
                return this.mdiVolumeLow;
            } else {
                return this.mdiVolumeMute;
            }
        },
        setVolume(): void {
            this.$emit("setVolume", this.userVolume);
        },
        closeDialog(): void {
            this.$emit("close");
        },
    },
});
